import React, { useState } from "react";
import ToggleTab from "../../NewComponents/ToggleTab/ToggleTab.component";
import styles from "./PrincipalsMain.module.scss";
import ExistingPrincipals from "./ExistingPrincipals";
import ProspectivePrincipals from "./ProspectivePrincipals";
import { showModal } from "../../redux/actions/modal";

export const PrincipalsMain = () => {
  const [activeTab, setActiveTab] = useState("current-principal");

  return (
    <div>
      <div
        className={`d-flex justify-content-between ${styles.mainHeadingContainer}`}
      >
        <h1 className={`ml-3 ${styles.headingPrincipal} `}>Principal</h1>
      </div>
      <div className="datatable-wrapper">
        <div className="table-view animated speed-1x fadeInRight">
          <div className="alignToggleTabItems row m-x-1 ">
            <ToggleTab
              text="Current or Existing Principal"
              id="current-principal"
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
            <ToggleTab
              text="Prospective Principal"
              id="prospective-principal"
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>

          {(() => {
            switch (activeTab) {
              case "current-principal":
                return <ExistingPrincipals />;
              case "prospective-principal":
                return <ProspectivePrincipals />;
              default:
                return null;
            }
          })()}
        </div>
      </div>
    </div>
  );
};
